// src/pages/AdminDashboard.jsx
import { useNavigate } from "react-router-dom";

export default function AdminDashboard() {
  const navigate = useNavigate();

  const Tile = ({ onClick, title, emoji, desc }) => (
    <button
      onClick={onClick}
      className="group relative overflow-hidden text-left rounded-xl p-4
                 bg-gradient-to-br from-[#6c56b5] to-[#2c204f]
                 text-white shadow-lg border border-white/10
                 hover:shadow-2xl transition
                 focus:outline-none focus:ring-2 focus:ring-purple-400/70"
    >
      {/* лъскав отблясък */}
      <span className="pointer-events-none absolute -top-16 -left-10 w-40 h-40 rotate-12 bg-white/10 blur-2xl rounded-full group-hover:bg-white/15 transition" />
      <div className="text-xl font-semibold mb-1">
        {emoji} <span className="font-bold">{title}</span>
      </div>
      <p className="text-sm text-white/80">{desc}</p>
    </button>
  );

  return (
    <div className="min-h-screen relative flex items-start md:items-center justify-center p-6">
      {/* Фон с леко размазване и пурпурен воал */}
      <div className="fixed inset-0 -z-10 overflow-hidden">
        <img
          src="https://latonacinema.com/wp-content/uploads/2025/06/cinema-hall-with-rows-of-grey-seats-in-darkness.jpg"
          alt="Латона Синема — фон"
          className="h-full w-full object-cover blur-[2px] scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#2c204f]/75 via-black/60 to-[#6c56b5]/65" />
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background:
              "radial-gradient(70% 60% at 50% 35%, rgba(0,0,0,0) 0%, rgba(0,0,0,.35) 60%, rgba(0,0,0,.7) 100%)",
          }}
        />
      </div>

      {/* Основна карта */}
      <div className="w-full max-w-5xl bg-white/8 backdrop-blur-xl border border-white/10 rounded-2xl shadow-2xl p-6 md:p-8">
        {/* Хедър с лого */}
        <div className="flex items-center justify-between gap-4 flex-wrap mb-6">
          <div className="flex items-center gap-3">
            <img
              src="https://latonacinema.com/wp-content/uploads/2025/06/cropped-latonacinema.png"
              alt="Латона Синема — лого"
              className="h-12 md:h-14"
            />
            <h1 className="text-2xl md:text-3xl font-extrabold tracking-tight text-white">
              👑 Администраторски панел
            </h1>
          </div>
          <p className="text-sm text-white/70">
            Добре дошли! Изберете секция за управление:
          </p>
        </div>

        {/* Плочки */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <Tile
            onClick={() => navigate("/admin/movies")}
            emoji="🎬"
            title="Филми"
            desc="Добавяне, редакция и изтриване"
          />

          <Tile
            onClick={() => navigate("/admin/showtimes")}
            emoji="📅"
            title="Прожекции"
            desc="Планиране и премахване на прожекции"
          />

          <Tile
            onClick={() => navigate("/admin/manage-cinema-movies")}
            emoji="🏢"
            title="Филми по кина"
            desc="Свързване на филми с кина"
          />

          {/* Заменя “Седмичен мениджър” */}

          <Tile
            onClick={() => navigate("/admin/promos")}
            emoji="🎟️"
            title="Промо кампании"
            desc="Кодове за отстъпка, валидност, обхват"
          />


          <Tile
            onClick={() => navigate("/admin/seat-planner")}
            emoji="🪑"
            title="План на залите"
            desc="Проектиране и запазване на разположения"
          />

          <Tile
            onClick={() => navigate("/admin/bar-manager")}
            emoji="🍿"
            title="Бар мениджър"
            desc="Добавяне / редакция / изтриване на артикули"
          />

          <Tile
            onClick={() => navigate("/admin/fiscal-devices")}
            emoji="🖨️"
            title="Фискални устройства"
            desc="Daisy FX-1300 · Ping · Данъчни групи"
          />

          <Tile
            onClick={() => navigate("/admin/users")}
            emoji="👥"
            title="Потребители"
            desc="Създаване, нулиране на пароли, роли"
          />

          <Tile
            onClick={() => navigate("/admin/recat")}
            emoji="👥"
            title="Рекатегоризация A→B"
            desc="Рекатегоризация A→B"
          />

          <Tile
            onClick={() => navigate("/admin/restore")}
            emoji="🧯"
            title="Restore Wizard"
            desc="Възстановяване от SQL dump (Admin only)"
          />

          <Tile
            onClick={() => navigate("/admin/auto-backup")}
            emoji="🕒"
            title="Авто бекъп"
            desc="Remote DB targets + график за автоматичен backup"
          />

          <Tile
            onClick={() => navigate("/admin/data-tools")}
            emoji="🗄️"
            title="Data Tools"
            desc="Export (XLSX/SQL) + Purge по период"
          />

<Tile
  onClick={() => navigate("/admin/movie-pricing")}
  emoji="💶"
  title="Цени по филм"
  desc="Override цени за кино + филм"
/>

          <Tile
            onClick={() => navigate("/admin/showtime-pricing")}
            emoji="🎟️"
            title="Цени по прожекция"
            desc="Override за конкретен филм, дата и час"
          />

        </div>





        {/* Долен ред със съвет */}
        <div className="mt-6 text-xs text-white/70">
          Съвет: Ползвайте{" "}
          <kbd className="px-1.5 py-0.5 rounded bg-white/10 border border-white/20">Tab</kbd> за
          навигация и <span className="font-semibold">Enter</span> за отваряне.
        </div>
      </div>
    </div>
  );
}
